import React from 'react';
import { Outlet } from 'react-router-dom';
import Toast from '../common/Toast/Toast';
import { useAppState } from '../../contexts/appState';

import CSratingsHeader from '../common/Header/CSratingsHeader';
import './Layout.css';

export default function CSratingsLayout() {
  const [appState] = useAppState();

  return (
    <div className="App">
      <CSratingsHeader selectedType="somethingELse" style={{ postion: 'fixed' }} />
      <Outlet />
      {appState?.alertSnackbar?.message && <Toast toastMsgObj={appState?.alertSnackbar || {}} />}
    </div>
  );
}
